import { render, staticRenderFns } from "./DocumentosPendentes.vue?vue&type=template&id=2a734536&"
import script from "./DocumentosPendentes.vue?vue&type=script&lang=js&"
export * from "./DocumentosPendentes.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosPendentes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports